'use strict';

positivePayController.$inject = ['$scope', '$rootScope', '$q', 'positivePayService', 'dialogHelper', 'BUSY_MESSAGE'];

angular.module('schoolLinqApp').controller('positivePayController', positivePayController);

function positivePayController($scope, $rootScope, $q, positivePayService, dialogHelper, BUSY_MESSAGE) {
	$scope.vm = getViewModel($rootScope.mode || 'fund');

	$scope.pageBusy = {
		message: BUSY_MESSAGE.Loading,
		promise: loadBanks($scope.vm),
	};

	$scope.formBusy = {
		message: BUSY_MESSAGE.Saving,
		promise: $q.resolve(),
	};

	function getViewModel(moduleName) {
		var model = {
			module: moduleName,
			checkDateOpen: false,
			data: {
				banks: [],
			},
			formValues: {
				BankId: null,
				CheckDate: null,
			},
		};

		function handleSubmit(model) {
			var body = _.clone(model.formValues);

			var promise = positivePayService
				.postFile(body)
				.then(function (response) {
					if (!response.data.IsValid) {
						return $q.reject(response.data.errors);
					}

					if (!response.data.file) {
						dialogHelper.openMessageBox('No Data Found', 'No unprinted checks were found that match the given criteria', null, 'Warning');

						return;
					}

					//create blob and save
					download('PositivePay.txt', response.data.file.Contents);
				})
				.catch(function (error) {
					var errorStr = error;

					if (error.data) {
						errorStr = error.data.Message;
					} else if (angular.isArray(error)) {
						errorStr = error.join(' ');
					}

					dialogHelper.openMessageBox('Unable to export Positive Pay file', errorStr, null, 'Error');
				});

			$scope.formBusy.promise = promise;
		}

		return angular.extend(model, {
			handleSubmit: _.partial(handleSubmit, model),
		});
	}

	function loadBanks(model) {
		var promise = positivePayService.getBanks().then(_.partial(finishedLoadingBanks, model));

		function finishedLoadingBanks(model, response) {
			model.data.banks = response.data.banks || [];

			if (model.data.banks && model.data.banks.length === 1) {
				model.formValues.BankId = model.data.banks[0].Id;
			}
		}

		return promise;
	}
}

function download(filename, base64) {
	var element = document.createElement('a');
	element.setAttribute('download', filename);

	element.setAttribute('href', 'data:text/plain;charset=utf-8;base64,' + base64);

	element.style.display = 'none';
	document.body.appendChild(element);

	element.click();

	document.body.removeChild(element);
}
